export const products = [
  {
    id: 1,
    title: "500 Gaming Credits",
    price: 5,
    img: "https://plus.unsplash.com/premium_photo-1769370513048-d8fb4e2f5dc9?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDU5fHx8ZW58MHx8fHx8",
  },
  {
    id: 2,
    title: "1000 Gaming Credits",
    price: 10,
    img: "https://plus.unsplash.com/premium_photo-1682124726112-9a9a55f04f32?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDUxfHx8ZW58MHx8fHx8",
  },
  {
    id: 3,
    title: "2000 Gaming Credits",
    price: 18,
    img: "https://plus.unsplash.com/premium_photo-1687919417131-c50f7d9a407a?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTl8fGdhbWluZyUyMHdhbGxwYXBlcnxlbnwwfHwwfHx8MA%3D%3D",
  },
];
